/**
 * Per-session boost rotation.
 * Each browser session gets a stable random offset on first visit,
 * so different users see different boosted listings at the top,
 * but the same user sees a consistent order within their session.
 */

function getSessionOffset() {
  if (typeof window === 'undefined') return 0;

  let sessionId = sessionStorage.getItem('boost_session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('boost_session_id', sessionId);
  }

  let hash = 0;
  for (let i = 0; i < sessionId.length; i++) {
    hash = ((hash << 5) - hash) + sessionId.charCodeAt(i);
    hash = hash & hash; // force 32-bit int
  }
  const offset = Math.abs(hash);

  if (process.env.NODE_ENV === 'development') {
    console.log('[BoostRotation] Session offset:', offset);
  }

  return offset;
}

/**
 * Rotate an array by the session offset.
 * Same session = same rotation every time. Different session = different start.
 */
export function rotateForSession(items) {
  if (!items || items.length === 0) return [];
  const offset = getSessionOffset() % items.length;
  return [...items.slice(offset), ...items.slice(0, offset)];
}

/**
 * Dev utility: clear the session rotation and reload to get a fresh offset.
 * Only used when ?dev=true is in the URL.
 */
export function resetSessionRotation() {
  sessionStorage.removeItem('boost_session_id');
  window.location.reload();
}

/**
 * Returns the current session's offset (for the dev panel).
 */
export function getDebugOffset() {
  if (typeof window === 'undefined') return 0;
  const sessionId = sessionStorage.getItem('boost_session_id');
  if (!sessionId) return 0;
  let hash = 0;
  for (let i = 0; i < sessionId.length; i++) {
    hash = ((hash << 5) - hash) + sessionId.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.abs(hash);
}
